import type { AxleListing } from '@contracts/axle/AxleListing';

export interface Tractor {
  id: string;
  unitNumber: string;
  make: string;
  model: string | null;
  fuelType: string | null;
  bodyStyle: string | null;
  type: string | null;
  vin: string;
  year: number;
  specialDesign: boolean;
  axles: AxleListing[];
  licensePlate: string;
  licensePlateState: string;
  licensePlateEffectiveDate: Date | null;
  licensePlateExpirationDate: Date | null;
  licensePlateType: string | null;
  licensePlateYear: number | null;
  licensePlateIsApportioned: boolean | null;
  length: number | null;
  width: number | null;
  height: number | null;
  wheelBase: number | null;
  groundHeight: number | null;
  unladenWeight: number | null;
  actualWeight: number | null;
  gvw: number | null;
  outerBridgeLength: number | null;
}

export class TractorList {
  constructor(public readonly tractors: Tractor[]) {}
}
